module.exports = __webpack_public_path__ + "static/SimulateHeroVid-1fc9b9b1337e38b082ab2e727cc128c0.mp4";